import { Component, Input } from '@angular/core';
import type { AliasedIcon } from 'components/icon-registry';
import { LoCard, LoSkeleton, LoStatus } from 'lo-design-system';

@Component({
	standalone: true,
	selector: 'meta-section',
	imports: [LoCard, LoSkeleton, LoStatus],
	template: `
		<lo-card [heading]="heading" [icon]="icon" [headingLevel]="2">
			<div loCardActions class="actions">
				@if (count !== null && count !== undefined && !loading) {
				<lo-status tone="neutral">{{ count }}</lo-status>
				}
				<ng-content select="[slot=header-action]"></ng-content>
			</div>
			<ng-content select="[slot=header-extra]"></ng-content>
			@if (loading) {
			<div class="skeletons" aria-busy="true">
				@for (n of skeletonItems; track n) {
				<lo-skeleton variant="row"></lo-skeleton>
				}
			</div>
			} @else {
			<ng-content></ng-content>
			}
		</lo-card>
	`,
	styles: [
		`
			:host {
				display: block;

				.actions {
					display: flex;
					align-items: center;
					gap: var(--lo-space-gap-md);
				}

				.skeletons {
					display: flex;
					flex-direction: column;
					gap: var(--lo-space-gap-md);
				}
			}
		`
	]
})
export class MetaSectionComponent {
	@Input() heading = '';
	/** Alias in the icon registry, drawn before the heading. */
	@Input() icon: AliasedIcon | undefined;
	@Input() count: string | number | null | undefined = null;
	@Input() loading = false;
	@Input() set skeletonRows(value: number) {
		this.skeletonItems = Array.from({ length: value }, (_, i) => i);
	}

	skeletonItems: number[] = [0, 1, 2];
}
